import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { TabPanel, TabView } from "primereact/tabview";
import React, { useState, useContext, useImperativeHandle } from "react";
import Labels from "../../../infrastructure/Labels_sr_Latn_RS";
import { axiosConfig, isFormDisabled, useEffectOnce } from "../../../utils/Utils";
import MessageType from "../../../infrastructure/MessageType";
import { AppContext } from "../../Store";
import { PickList } from "primereact/picklist";
import EntityOperation from "../../../infrastructure/EnumEntityOperation";
import Endpoint from "../../../endpoints/Endpoint";
import axios from "axios";
import { Messages } from "primereact/messages";

interface CrudKategorijeIzvestajaProps {
  kategorijaIzvestajaOperation: string;
  kategorijaIzvestaja?: any;
  onCreateKategorijaIzvestaja: Function;
  onUpdateKategorijaIzvestaja: Function;
  onDeleteKategorijaIzvestaja: Function;
  onCancel: Function;
  dialogRef?: any;
  setIndex: Function;
  index: number;
}

export default function CrudKategorijeIzvestaja(props: CrudKategorijeIzvestajaProps) {
  const { kategorijaIzvestajaOperation, kategorijaIzvestaja, onCreateKategorijaIzvestaja, onUpdateKategorijaIzvestaja, onDeleteKategorijaIzvestaja, dialogRef, setIndex, index } = props;
  const [kategorijaIzvestajaChange, setKategorijaIzvestajaChange] = useState<Partial<any>>(kategorijaIzvestaja);
  const { showGrowlMessage } = useContext(AppContext);
  const { authData } = useContext(AppContext);
  const [ulogaList, setUlogaList] = useState([]);

  const [hasUlogaList, setHasUlogaList] = useState([]);
  let [messages, setMessages] = useState<Messages>();

  const validateInput = (message: string) => {
    if (!kategorijaIzvestajaChange || !kategorijaIzvestajaChange.naziv) {
      showGrowlMessage(MessageType.ERROR, message, Labels.MESSAGES_POLJE_NAZIV);
      return false;
    }
    if (!kategorijaIzvestajaChange || !kategorijaIzvestajaChange.numerickaVrednost) {
      showGrowlMessage(MessageType.ERROR, message, Labels.MESSAGES_NUMERICKA_VREDNOST);
      return false;
    }
    return true;
  };
  const showError = (summary: string, detail: string) => {
    if (messages) {
      messages.replace({
        severity: "error",
        summary: summary,
        detail: detail,
        closable: true,
        sticky: true,
      });
    }
  };

  useEffectOnce(() => {
    if (kategorijaIzvestaja) {
      const requestImaKategorijaStatistickogIzvestaja = axios.get(
        Endpoint.ULOGA_KATEGORIJA_STATISTICKOG_IZVESTAJA + "/search/findUlogaKategorijaStatistickogIzvestajaByKategorijaStatistickogIzvestaja",
        axiosConfig(authData.token, { kategorijaStatistickogIzvestaja: Endpoint.KATEGORIJA_STATISTICKOG_IZVESTAJA + "/" + kategorijaIzvestaja.id, aktivan: true })
      );

      const requestUloge = axios.get(
        Endpoint.ULOGA + "/search/findByAktivan",
        axiosConfig(authData.token, {
          page: 0,
          size: 50000000,
          aktivan: true,
        })
      );

      axios
        .all([requestImaKategorijaStatistickogIzvestaja, requestUloge])
        .then(
          axios.spread((responseImaKategorijaStatistickogIzvestaja: any, responseUloge: any) => {
            const ulogeArray = responseUloge.data._embedded.ulogas;
            const hasUlogeArray = responseImaKategorijaStatistickogIzvestaja.data._embedded.ulogas;
            const imaUlogaID = hasUlogeArray.map((p: any) => {
              return p.id;
            });
            const nemaUlogaArray = ulogeArray.filter((p: any) => !imaUlogaID.includes(p.id));
            setHasUlogaList(hasUlogeArray);
            setUlogaList(nemaUlogaArray);
          })
        )
        .catch((error: any) => {
          showError(Labels.TITLE_MESSAGES_GRESKA, error);
        });
    }
  });

  useImperativeHandle(dialogRef, () => ({
    onCreate: () => {
      if (!validateInput(Labels.TITLE_MESSAGES_GRESKA_PRILIKOM_KREIRANJA)) {
        return;
      }
      onCreateKategorijaIzvestaja(kategorijaIzvestajaChange)
        .then(() => {})
        .catch((error: any) => {
          showGrowlMessage(MessageType.ERROR, Labels.TITLE_MESSAGES_GRESKA_PRILIKOM_KREIRANJA, error);
        });
    },
    onUpdate: () => {
      if (!validateInput(Labels.TITLE_MESSAGES_GRESKA_PRILIKOM_IZMENE)) {
        return;
      }
      onUpdateKategorijaIzvestaja(kategorijaIzvestajaChange)
        .then(() => {})
        .catch((error: any) => {
          showGrowlMessage(MessageType.ERROR, Labels.TITLE_MESSAGES_GRESKA_PRILIKOM_IZMENE, error);
        });
    },
    onDelete: () => {
      onDeleteKategorijaIzvestaja(kategorijaIzvestajaChange)
        .then(() => {})
        .catch((error: any) => {
          showGrowlMessage(MessageType.ERROR, Labels.TITLE_MESSAGES_GRESKA_PRILIKOM_BRISANJA, error);
        });
    },
  }));

  const onChangeUloga = (event: any) => {
    if (hasUlogaList.length < event.target.length) {
      const hasUlogaID = hasUlogaList.map((p: any) => p.id);
      event.target.forEach((uloga: any) => {
        if (!hasUlogaID.includes(uloga.id)) {
          const ulogaKategorijaStatistickogIzvestaja = {
            uloga: uloga._links.self.href,
            kategorijaStatistickogIzvestaja: kategorijaIzvestaja._links.self.href,
          };
          axios.post(Endpoint.ULOGA_KATEGORIJA_STATISTICKOG_IZVESTAJA, ulogaKategorijaStatistickogIzvestaja, axiosConfig(authData.token));
        }
      });
      setHasUlogaList(event.target);
      setUlogaList(event.source);
    } else if (ulogaList.length < event.source.length) {
      const ulogaListID = ulogaList.map((aplPravo: any) => aplPravo.id);
      const ulogaDelete: any[] = [];
      event.source.forEach((uloga: any) => {
        if (!ulogaListID.includes(uloga.id)) {
          ulogaDelete.push(uloga.id);
        }
      });
      axios
        .post(
          Endpoint.ULOGA_KATEGORIJA_STATISTICKOG_IZVESTAJA_DELETE,
          {
            ulogaID: ulogaDelete,
            kategorijaStatistickogIzvestajaID: kategorijaIzvestaja.id,
          },
          axiosConfig(authData.token)
        )
        .then((res: any) => {
          setHasUlogaList(event.target);
          setUlogaList(event.source);
        })
        .catch((error: any) => {
          showError(Labels.TITLE_MESSAGES_GRESKA_PRILIKOM_BRISANJA, error);
        });
    }
  };

  const ulogaTemplate = (object: any) => (
    <div className="p-clearfix">
      <div>{object.ime}</div>
    </div>
  );

  return (
    <div className="panel-report">
      <TabView
        renderActiveOnly={false}
        activeIndex={index}
        onTabChange={(e) => {
          setIndex(e.index);
        }}
      >
        <TabPanel header={Labels.TAB_KATEGORIJA_IZVESTAJA}>
          <div>
            <div className="xl-6 lg-6 md-6 sm-12">
              <div className="grid align-items-center">
                <div className="col-4">{Labels.LABEL_NAZIV}</div>
                <div className="col-8">
                  <InputText
                    disabled={isFormDisabled(kategorijaIzvestajaOperation)}
                    value={kategorijaIzvestajaChange && kategorijaIzvestajaChange.naziv ? kategorijaIzvestajaChange.naziv : ""}
                    onChange={(e: any) => {
                      setKategorijaIzvestajaChange({
                        ...kategorijaIzvestajaChange,
                        naziv: e.target.value,
                      });
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="xl-6 lg-6 md-6 sm-12">
              <div className="grid align-items-center">
                <div className="col-4">{Labels.LABEL_NUMERICKA_VREDNOST}</div>
                <div className="col-8">
                  <InputNumber
                    disabled={isFormDisabled(kategorijaIzvestajaOperation)}
                    value={kategorijaIzvestajaChange && kategorijaIzvestajaChange.numerickaVrednost ? kategorijaIzvestajaChange.numerickaVrednost : null}
                    onValueChange={(e: any) => {
                      setKategorijaIzvestajaChange({
                        ...kategorijaIzvestajaChange,
                        numerickaVrednost: e.target.value,
                      });
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </TabPanel>
        <TabPanel header={Labels.TAB_ULOGE} disabled={kategorijaIzvestajaOperation === EntityOperation.CREATE}>
          <PickList
            source={ulogaList}
            target={hasUlogaList}
            itemTemplate={ulogaTemplate}
            sourceHeader="Uloge koje ne vide kategoriju"
            targetHeader="Uloge koje vide kategoriju"
            sourceStyle={{ height: "650px" }}
            targetStyle={{ height: "650px" }}
            onChange={onChangeUloga}
            showSourceControls={false}
            showTargetControls={false}
            style={{ pointerEvents: isFormDisabled(kategorijaIzvestajaOperation) ? "none" : "" }}
          />
        </TabPanel>
      </TabView>
    </div>
  );
}
